




















































































/* eslint-disable class-methods-use-this */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import BaseComponent from '@/components/BaseComponent';
import FormTextInput from '@/components/shared/FormTextInput.vue';
import GeometryType from '@/models/map-context/GeometryType';
import LayerConfig from '@/models/map-context/LayerConfig';
import TextStyle from '@/models/map-context/style/TextStyle';
import Component from 'vue-class-component';
import { Watch } from 'vue-property-decorator';

@Component({
  props: {
    textStyle: TextStyle,
    layer: LayerConfig,
  },
  components: {
    FormTextInput,
  },
})
export default class TexteStyleDefinition extends BaseComponent {
  textStyle!:TextStyle;

  layer!:LayerConfig;

  positionList=['center', 'end', 'left', 'right', 'start'];

  fontList=['Arial','Courier New','Georgia', 'Tahoma', 'Times New Roman', 'Trebuchet MS', 'Verdana'];

  mounted(){
    this.checkGeom();
  }
  
  @Watch('layer.geometryType')
  onChangeType(event: any){
    this.checkGeom();
  }
  
  checkGeom(){
    // Pour les lignes on précise que c'est une ligne dans le style
    // pour le placement du label
    if(this.layer.geometryType == GeometryType.LINE){
      this.textStyle.lineGeom= true;
    }
    else{
      this.textStyle.lineGeom= false;
    }
    if(this.layer.geometryType == GeometryType.POLYGON){
      this.textStyle.useCentroid= true;
      this.textStyle.geomAttributeName=this.layer.getGeomAttributeName();
    }
    else{
      this.textStyle.useCentroid= false;
    }
  }
  addField(field:any) {
    this.textStyle.text += `{${field.name}}`;
  }

  addFieldToZoffset(field:any) {
    this.textStyle.offsetZ = `{${field.name}}`;
  }

  get showFollowLine():boolean {
    return this.layer.geometryTypeNotDefined()
    || this.layer.geometryType == GeometryType.LINE;
  }
}
